import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'
import {
  sharedStyles,
  sharedColors,
} from '../../../sharedDisplays/sharedStyles'

const header = {
  ...sharedStyles.headerLayout,
  marginBlockStart: 17,
  marginInlineEnd: 19,
  marginBlockEnd: 17,
  marginInlineStart: 16,
}

const avatarUsername = (locationVisible, display) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  '.kuiper-account-name': {
    ...sharedStyles.accountPosition(locationVisible, display),
    fontSize: fontSizes.large,
  },
})

const accountNameStyles = {
  color: 'inherit',
  display: 'inline',
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bolder,
}

const emptyCollabStyles = {
  color: colors.orange.base,
  display: 'inline',
  fontSize: fontSizes.small,
  fontWeight: fontWeights.bolder,
}

const accountNameWrapperStyles = {
  fontSize: fontSizes.small,
  marginLeft: 10,
  maxWidth: 360,
  overflow: 'hidden',
  paddingBlockEnd: 20,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const location = {
  ...sharedStyles.locationPosition,
  fontSize: fontSizes.small,
  lineHeight: '21px',
  maxInlineSize: '500px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const addCommentText = {
  ...sharedStyles.addCommentText,
}

const contentWrapper = {
  marginBlock: 20,
  marginInline: 16,
  position: 'relative',
}

const textarea = () => ({
  fontSize: fontSizes.large,
})

const accountMeasurer = {
  ...sharedStyles.accountMeasurer,
}

const avatar = {
  border: `solid 1px ${sharedColors.avatarBorderColor}`,
  marginInlineEnd: 12,
}

const responseList = {
  ...sharedStyles.responseList,
  marginBlockStart: 12,
  marginInlineEnd: 16,
  marginBlockEnd: 0,
  marginInlineStart: 18,
}

const responseItem = ({ bookmark = false }) => ({
  ...sharedStyles.responseItem({ bookmark }),
  '.kuiper-icon': {
    blockSize: 24,
    marginInlineEnd: bookmark ? 0 : 17,
    inlineSize: 24,
  },
})

const postedAt = {
  ...sharedStyles.postedAt,
  marginBlockStart: 0,
  marginInlineEnd: 20,
  marginBlockEnd: 12,
  marginInlineStart: 20,
}

const makeAssetBaseStyles = (maintainAspectRatio) => ({
  backgroundColor: sharedColors.imageBackground,
  ...(maintainAspectRatio && {
    maxBlockSize: 766,
    minBlockSize: 320,
  }),
})

const makeAssetStyles = (maintainAspectRatio) => ({
  video: {
    inlineSize: '100%',
    maxWidth: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  ...(maintainAspectRatio && {
    display: 'flex', // Ensure container fits to size of asset
    maxBlockSize: 766,
    minBlockSize: 320,
    'img, video': {
      inlineSize: '100%',
      maxBlockSize: 766,
      minBlockSize: 320,
      objectFit: 'cover',
    },
  }),
})

const flexColumn = {
  display: 'flex',
  flexDirection: 'column',
}

export const styles = {
  accountMeasurer,
  accountNameStyles,
  accountNameWrapperStyles,
  addCommentText,
  avatar,
  avatarUsername,
  contentWrapper,
  emptyCollabStyles,
  header,
  location,
  makeAssetStyles,
  makeAssetBaseStyles,
  postedAt,
  responseItem,
  responseList,
  textarea,
  flexColumn,
}
